// Mock data for Lead Magnets and Assets

export const mockLeadMagnets = [
  {
    id: 'lm-1',
    internalName: 'AI Strategy Guide',
    status: 'published',
    slug: 'ai-strategy-guide-x7k2m',
    pageTitle: 'Free AI Strategy Guide for Business Leaders',
    heroHeadline: 'Transform Your Business with AI',
    heroSubHeadline: 'Discover proven strategies to implement AI in your organization',
    bulletPoints: [
      '10 proven AI implementation strategies',
      'Real-world case studies from Fortune 500 companies',
      'Step-by-step roadmap for your first AI project',
      'Common pitfalls to avoid'
    ],
    credibilityText: 'Trusted by 10,000+ business leaders worldwide',
    formCtaText: 'Download Free Guide',
    seoTitle: 'Free AI Strategy Guide | Business AI Implementation',
    seoDescription: 'Download our comprehensive guide to implementing AI in your business. Learn from real case studies and get a step-by-step roadmap.',
    assetId: 'asset-1',
    createdDate: '2024-01-15T10:30:00Z',
    lastUpdated: '2024-01-20T14:22:00Z',
  },
  {
    id: 'lm-2',
    internalName: 'Digital Transformation Checklist',
    status: 'draft',
    slug: null,
    pageTitle: 'Digital Transformation Checklist',
    heroHeadline: 'Your Complete Digital Transformation Checklist',
    heroSubHeadline: 'Ensure nothing is missed in your digital transformation journey',
    bulletPoints: [
      '50-point comprehensive checklist',
      'Industry-specific recommendations',
      'Timeline and resource planning templates'
    ],
    credibilityText: 'Created by digital transformation experts',
    formCtaText: 'Get Checklist',
    seoTitle: null,
    seoDescription: null,
    assetId: null,
    createdDate: '2024-01-18T09:15:00Z',
    lastUpdated: '2024-01-19T16:45:00Z',
  },
  {
    id: 'lm-3',
    internalName: 'Customer Success Playbook',
    status: 'archived',
    slug: 'customer-success-playbook-a9b3c',
    pageTitle: 'Customer Success Playbook',
    heroHeadline: 'Master Customer Success',
    heroSubHeadline: 'Learn the frameworks used by top SaaS companies',
    bulletPoints: [
      'Customer success frameworks',
      'Retention strategies',
      'Upsell and cross-sell techniques'
    ],
    credibilityText: 'Based on data from 500+ SaaS companies',
    formCtaText: 'Download Playbook',
    seoTitle: 'Customer Success Playbook | SaaS Best Practices',
    seoDescription: 'Download our comprehensive customer success playbook with proven frameworks and strategies.',
    assetId: 'asset-2',
    createdDate: '2023-12-10T11:00:00Z',
    lastUpdated: '2024-01-05T10:30:00Z',
  },
  {
    id: 'lm-4',
    internalName: 'Marketing Automation Guide',
    status: 'published',
    slug: 'marketing-automation-guide-p4q8r',
    pageTitle: 'Complete Guide to Marketing Automation',
    heroHeadline: 'Automate Your Marketing',
    heroSubHeadline: 'Save 20+ hours per week with smart automation',
    bulletPoints: [
      'Marketing automation workflows',
      'Tool recommendations and comparisons',
      'ROI calculation templates',
      'Implementation best practices'
    ],
    credibilityText: 'Used by marketing teams at 5,000+ companies',
    formCtaText: 'Get Free Guide',
    seoTitle: 'Marketing Automation Guide | Free Download',
    seoDescription: 'Learn how to automate your marketing and save time. Download our comprehensive guide with workflows and templates.',
    assetId: 'asset-3',
    createdDate: '2024-01-10T08:20:00Z',
    lastUpdated: '2024-01-22T13:10:00Z',
  },
];

export const mockAssets = [
  {
    id: 'asset-1',
    fileName: 'ai-strategy-guide.pdf',
    fileSize: 2456789, // bytes
    fileType: 'application/pdf',
    uploadDate: '2024-01-15T10:25:00Z',
    usedByMagnets: ['lm-1'],
  },
  {
    id: 'asset-2',
    fileName: 'customer-success-playbook.zip',
    fileSize: 5234567,
    fileType: 'application/zip',
    uploadDate: '2023-12-10T10:55:00Z',
    usedByMagnets: ['lm-3'],
  },
  {
    id: 'asset-3',
    fileName: 'marketing-automation-guide.pdf',
    fileSize: 3123456,
    fileType: 'application/pdf',
    uploadDate: '2024-01-10T08:15:00Z',
    usedByMagnets: ['lm-4'],
  },
  {
    id: 'asset-4',
    fileName: 'digital-transformation-checklist.xlsx',
    fileSize: 156789,
    fileType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    uploadDate: '2024-01-18T09:10:00Z',
    usedByMagnets: [],
  },
];

// Helper function to format file size
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};

// Helper function to format date
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

